'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: {
    padding: '16px',
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: _colors2.default.secondaryText,
    margin: 0,
    fontWeight: 'bolder',
    fontSize: '16px'
  },
  subtitle: {
    color: _colors2.default.grey,
    marginTop: '8px',
    marginBottom: '0',
    fontWeight: 'bolder',
    fontSize: '14px'
  },
  avatar: {
    marginRight: '16px',
    flexShrink: 0
  }
};
module.exports = exports.default;